<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.editMessage {
  width: 40%;
  right: 0;
  top: 0;
  background: #e6e6e6;
  z-index: 10;
  overflow: scroll;
}

.closeBtn {
  width: 2.5rem;
  height: 2.5rem;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.input-number {
  width: 70px;
}

.text-area {
  min-height: 4rem;
}

.empty-cta-style {
  border: 2px solid red;
}

.input-width {
  width: 6rem;
}
</style>

<template>
  <div class="editMessage position-fixed h-100 px-5 d-flex align-items-center">
    <div class="w-100">
      <b-row class="justify-content-between w-100">
        <b-btn
          @click="closeModal"
          variant="creativeLibrary"
          class="closeBtn d-flex align-items-center justify-content-center"
          ><img src="@/assets/images/pictos/cross.svg" width="12" height="12"
        /></b-btn>
        <h3 class="text-center">Edit banner</h3>
        <span></span>
      </b-row>
      <div>
        <TextEditor label="Text" v-model="text" />
        <TextEditor label="Offer" v-model="offer" />
        <TextEditor label="Terms"  v-model="terms" />
        <b-form-group
          class="my-4 d-flex align-items-center"
          label-cols="4"
          label-cols-lg="2"
          label-size="Default"
          label="CTA"
          label-for="input-default"
          label-align="right"
          label-class="p-0 mr-3"
        >
          <b-form-select id="ctaname" v-model="cta" :options="listctanames"></b-form-select>
        </b-form-group>
        <b-form-group
          v-if="!dataInDb"
          class="my-4 d-flex align-items-center"
          label-cols="4"
          label-cols-lg="2"
          label-size="Default"
          label="CTA Style"
          label-for="input-default"
          label-align="right"
          label-class="p-0 mr-3"
        >
          <b-form-select
            id="ctastyle"
            v-model="ctaStyle"
            :options="listctastyles"
            :class="!ctaStyle && 'empty-cta-style'"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          class="my-4 d-flex align-items-center"
          label-cols="4"
          label-cols-lg="2"
          label-size="Default"
          label="Logo position"
          label-for="input-default"
          label-align="right"
          label-class="p-0 mr-3"
        >
          <b-row class="d-flex justify-content-between m-0">
            <b-col sm="8">
              <div class="d-flex w-100 justify-content-center">
                <label for="logoPosition">Translate</label>
              </div>
              <b-row style="gap: 0.5rem">
                <b-input-group class="p-0 input-width" size="default" append="x">
                  <b-form-input
                    id="logoX"
                    name="logoX"
                    type="number"
                    v-model="logoTransform.x"
                    class="input-number"
                    required
                    append="x"
                  ></b-form-input>
                </b-input-group>
                <b-input-group class="p-0 input-width" size="default" append="y">
                  <b-form-input
                    id="logoY"
                    name="logoY"
                    type="number"
                    v-model="logoTransform.y"
                    class="input-number"
                    required
                  ></b-form-input>
                </b-input-group>
              </b-row>
            </b-col>

            <b-col sm="4" class="d-flex flex-column align-items-center m-0 p-0">
              <div class="d-flex w-100 justify-content-center">
                <label for="logoPosition">Scale</label>
              </div>
              <b-input-group class="p-0 input-width" size="default" append="%">
                <b-form-input
                  id="logoScale"
                  name="logoScale"
                  type="number"
                  v-model="logoTransform.scale"
                  class="input-number"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group
          class="my-4 d-flex align-items-center"
          label-cols="4"
          label-cols-lg="2"
          label-size="Default"
          label="Video position"
          label-for="input-default"
          label-align="right"
          label-class="p-0 mr-3"
          v-if="type === 'square'"
        >
          <b-row class="d-flex justify-content-between m-0">
            <b-col sm="8">
              <div class="d-flex w-100 justify-content-center">
                <label for="videoPosition">Translate</label>
              </div>
              <b-row style="gap: 0.5rem">
                <b-input-group class="p-0 input-width" size="default" append="x">
                  <b-form-input
                    id="videoX"
                    name="videoX"
                    type="number"
                    v-model="videoTransform.x"
                    class="input-number"
                    required
                  ></b-form-input>
                </b-input-group>
                <b-input-group class="p-0 input-width" size="default" append="y">
                  <b-form-input
                    id="videoY"
                    name="videoY"
                    type="number"
                    v-model="videoTransform.y"
                    class="input-number"
                    required
                  ></b-form-input>
                </b-input-group>
              </b-row>
            </b-col>
          </b-row>
        </b-form-group>
        <b-row class="mt-4 justify-content-end">
          <b-btn class="mr-4" type="reset" variant="light" @click="preview">Preview</b-btn>
          <b-btn type="submit" class="border-0 d-flex" variant="creativeLibrary" @click="submit" id="hoverWarning">
            <b-spinner label="Loading..." v-if="loading"></b-spinner>
            <span v-else>Save</span></b-btn
          >
          <b-tooltip target="hoverWarning" triggers="hover"><b>Warning:</b> this action modifies real data</b-tooltip>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import TextEditor from "@/views/liveEdit/TextEditor.vue";

export default {
  name: "EditMessage",
  components: { TextEditor },
  data() {
    return {
      text: "",
      offer: "",
      terms: "",
      cta: "",
      ctaStyle: "",
      logoTransform: {},
      videoTransform: {},
      listctanames: [],
      listctastyles: [],
    };
  },
  props: {
    ctaNamesTable: { type: Array, required: false },
    assetsLangTable: { type: Array, required: false },
    assetsDesignTable: { type: Array, required: false },
    size: { type: String, required: false },
    type: { type: String, required: false },
    market: { type: String, required: false },
    message: { type: String, required: false },
    loading: { type: Boolean, required: true },
    dataInDb: { type: Boolean, required: true },
    initData: { type: Object, required: true },
  },

  computed: {
    ctaNames() {
      return this.dataInDb
        ? [...new Set(this.ctaNamesTable.map((v) => v.variant))]
        : [
            ...new Set(
              this.ctaNamesTable.filter((market) => market.lang.includes(this.market)).map((cta) => cta["#Cta list"])
            ),
          ];
    },
    ctaStyles() {
      if (this.dataInDb) {
        return [];
      }
      return [
        ...new Set(
          this.ctaNamesTable
            .filter((el) => el.lang.includes(this.market) && el["#Cta list"] === this.cta)
            .map((cta) => cta["#Cta style"])
        ),
      ];
    },
    newData() {
      let variantData = null;
      if (this.dataInDb) {
        variantData = this.ctaNamesTable.find((v) => v.variant === this.cta);
      }
      return {
        text: this.text,
        offer: this.offer,
        terms: this.terms,
        cta: variantData ? variantData.cta : this.cta,
        borderCta: variantData?.borderCta || "",
        borderRadiusCta: variantData?.borderRadiusCta || "",
        ctaStyle: this.ctaStyle,
        logoTransform: {
          x: parseInt(this.logoTransform.x),
          y: parseInt(this.logoTransform.y),
          scale: this.logoTransform.scale,
        },
        videoTransform: {
          x: parseInt(this.videoTransform.x),
          y: parseInt(this.videoTransform.y),
        },
      };
    },
    frame1() {
      return this.initData?.data?.frames?.frame1?.data || {};
    },
    global() {
      return this.initData?.data?.global || {};
    },
  },

  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    submit() {
      this.$emit("submit", this.newData);
    },
    preview() {
      this.$emit("preview", this.newData);
    },
    findLangRow(sizeOrType) {
      return this.assetsLangTable.find(
        (el) =>
          el["#Market"] === this.market &&
          el["#Campaign Naming"] === this.message &&
          el["#Size Category"] === sizeOrType
      );
    },
    findDesignRow(sizeOrType) {
      return this.assetsDesignTable.find(
        (el) => el["#Campaign Naming"] === this.message && el["#Size Category"] === sizeOrType
      );
    },
    getDataFrame(variable) {
      const row = this.findLangRow(this.size) || this.findLangRow(this.type);
      return row[variable];
    },
    getDataDesign(variable) {
      const row = this.findDesignRow(this.size) || this.findDesignRow(this.type);
      return row[variable];
    },
    updateData() {
      this.text = this.getDataFrame("Tagline");
      this.offer = this.getDataFrame("Offer");
      this.terms = this.getDataFrame("ML");
      this.cta = this.getDataFrame("CTA");
      this.ctaStyle = this.getDataFrame("CTA Style");
      this.listctanames = this.ctaNames;
      this.listctastyles = this.ctaStyles;
      this.logoTransform = {
        x: parseInt(this.getDataDesign("logoTransform").split("translate(")[1].split(",")[0]),
        y: parseInt(this.getDataDesign("logoTransform").split(",")[1].split(")")[0]),
        scale: parseInt(this.getDataDesign("logoTransform").split("scale(")[1].split(")")[0]),
      };
      this.videoTransform = {
        x: parseInt(this.getDataDesign("videoTransform").split("translate(")[1].split(",")[0]),
        y: parseInt(this.getDataDesign("videoTransform").split(",")[1].split(")")[0]),
      };
    },
    updateDataInDb() {
      this.text = this.frame1["txt1"];
      this.offer = this.frame1["txt2"];
      this.terms = this.frame1["terms"];
      const variantMatch = this.ctaNamesTable.find((v) => v.cta === this.frame1["cta"]);
      this.cta = variantMatch ? variantMatch.variant : "";
      this.listctanames = this.ctaNames;
      this.logoTransform = {
        x: parseInt(this.global["logoTransform"].split("translate(")[1].split(",")[0]),
        y: parseInt(this.global["logoTransform"].split(",")[1].split(")")[0]),
        scale: parseInt(this.global["logoTransform"].split("scale(")[1].split(")")[0]),
      };
      this.videoTransform = {
        x: parseInt(this.global["videoTransform"].split("translate(")[1].split(",")[0]),
        y: parseInt(this.global["videoTransform"].split(",")[1].split(")")[0]),
      };
    },
  },
  watch: {
    message() {
      this.dataInDb ? this.updateDataInDb() : this.updateData();
    },
    size() {
      this.dataInDb ? this.updateDataInDb() : this.updateData();
      this.listctanames = this.ctaNames;
    },
    cta() {
      this.listctastyles = this.ctaStyles;
      if (!this.listctastyles.includes(this.ctaStyle)) {
        this.ctaStyle = "";
      }
    },
  },
  mounted() {
    if (this.dataInDb) {
      this.updateDataInDb();
    } else {
      this.updateData();
      this.listctastyles = [
        ...new Set(
          this.ctaNamesTable.filter((el) => el["#Cta list"]?.includes(this.cta)).map((cta) => cta["#Cta style"])
        ),
      ];
    }
  },
};
</script>
